module.exports = "/_next/static/images/icon-arrow-next-026566c95226af6cc3a8ee3545f7321a.png";